module.exports = __webpack_public_path__ + "static/media/towerSample-mobile.c9c51940.png";